import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, memo } from 'react';
import { ControlLabel, FormControl, Panel, Label, Row, Col } from '@cancercentrum/rcc-bootstrap';
import { incaAccessor } from '@cancercentrum/inca';
import { GenderIcon } from '../GenderIcon';
import { useI18n } from '../../i18n';
import { IncaContext } from '../ScopedIncaContext/IncaContext';
/**
 * Shows information about a patient from inca.form.env or from e.g. api/Patients/{id} or api/Patients/Find.
 */ const Personuppgifter = (props)=>{
    const { defaultExpanded, patient, LKVidDiagnos } = props;
    const { t } = useI18n();
    const scopedInca = useContext(IncaContext);
    const inca = incaAccessor();
    const person = patient || scopedInca?.patient || inca.form.env;
    const firstname = person._FIRSTNAME || person.firstName;
    const surname = person._SURNAME || person.lastName;
    const dateOfDeath = person._DATEOFDEATH || person.dateOfDeath;
    const ssn = person._PERSNR || person.ssn;
    const gender = person._SEX || person.gender;
    return /*#__PURE__*/ _jsxs(Panel, {
        className: "collapsible personuppgifter",
        defaultExpanded: !!defaultExpanded,
        children: [
            /*#__PURE__*/ _jsx(Panel.Heading, {
                children: /*#__PURE__*/ _jsxs(Panel.Title, {
                    toggle: true,
                    children: [
                        /*#__PURE__*/ _jsx(GenderIcon, {
                            gender: gender
                        }),
                        " ",
                        surname,
                        ", ",
                        firstname,
                        " ",
                        /*#__PURE__*/ _jsx(Label, {
                            bsStyle: "success",
                            children: ssn
                        }),
                        " ",
                        dateOfDeath && /*#__PURE__*/ _jsxs(Label, {
                            bsStyle: "danger",
                            children: [
                                t('component.personuppgifter.deceased'),
                                " ",
                                dateOfDeath
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Panel.Collapse, {
                children: /*#__PURE__*/ _jsx(Panel.Body, {
                    children: /*#__PURE__*/ _jsx("form", {
                        children: /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        noGutters: true,
                                        children: [
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.ssn')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: ssn
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.lastname')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: surname
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.firstname')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: firstname
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.address')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: person._ADDRESS || person.streetAddress
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.postalcode')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: person._POSTALCODE || person.postalCode
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.city')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: person._CITY || person.city
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        noGutters: true,
                                        children: [
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.gender')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: gender
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.deathdate')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: dateOfDeath
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.lk')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsxs(FormControl.Static, {
                                                    children: [
                                                        person.county ?? person._LAN,
                                                        person.municipality ?? person._KOMMUN
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.district')
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: person._DISTRICT || person.district
                                                })
                                            }),
                                            LKVidDiagnos && /*#__PURE__*/ _jsx(ControlLabel, {
                                                column: true,
                                                xs: 4,
                                                children: t('component.personuppgifter.lkdia')
                                            }),
                                            LKVidDiagnos && /*#__PURE__*/ _jsx(Col, {
                                                xs: 8,
                                                children: /*#__PURE__*/ _jsx(FormControl.Static, {
                                                    children: LKVidDiagnos
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Personuppgifter);
